import { Component, OnInit } from '@angular/core';
import { GuideService } from '../services/guide.service';
import { IGuide } from '../models/guide';

@Component({
  selector: 'learningmodules-completed',
  templateUrl: './learningmodules-completed.component.html',
  providers: [GuideService]
})
export class LearningmodulesCompletedComponent implements OnInit {

  totalSections: number = 0;
  completedSection: number = 0;
  percentCompletedSection: number = 0;

  guide: IGuide;

  constructor(private _guideService: GuideService) { }

  ngOnInit() {
    this.checkForCompletedGuides();
  }


  checkForCompletedGuides() {
    this._guideService.get().subscribe(res => {

      this.guide = res;

      for (var group of this.guide.groups) {

        this.totalSections += group.sections.length;

        for (var i = 0; i < group.sections.length; i++) {

          group.sections[i].alpha
          group.sections[i].number

          /*var modules = group.modules.filter(f => f.alpha == group.sections[i].alpha && f.number == group.sections[i].number);*/
          var modules = group.modules.filter(f => f.alpha == group.sections[i].alpha);

          if (modules.length == modules.filter(f => f.complete).length) {
            group.sections[i].complete = true;

            this.completedSection += 1;
          }

        }

      }

      this.percentCompletedSection = (this.completedSection / this.totalSections) * 100;

    });
  }

}
